import { BEATS, SEAT_INDEX } from "../lib/beats";
import WalkIn from "../components/WalkIn";

/** PlayForward: the Pursuital Arcade, seven beats from the door to the chair. */
export default function Arcade() {
  return (
    <WalkIn
      beats={BEATS}
      realm="playforward"
      pathPrefix="/playforward/walk"
      arriveIndex={SEAT_INDEX}
      arriveTo="/playforward/cove"
      arriveLabel="Take the chair"
      skipLabel="Straight to the Cove"
      placeName="Pursuital Arcade"
      choiceLine="Walk yourself in, or let the place carry you?"
    />
  );
}
